/* eslint-disable camelcase */
import Alert from 'react-s-alert';

import { ServerIp } from '../constants/env';

export const handleLogin = (username, password) => (dispatch) => {
  fetch(`${ServerIp}/api/v1/sessions/create`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      user: {
        username,
        password,
      },
    }),
  }).then((res) => {
    if (res.status < 400) {
      res.json().then((data) => {
        localStorage.setItem('token', data.auth_token);
        localStorage.setItem('user', data.username);
        dispatch({
          type: 'LOGIN_SUCCESS',
          payload: data,
        });
      });
    } else {
      dispatch({
        type: 'LOGIN_FAIL',
        payload: 'Email or password are wrong, pleas try again!',
      });
      setTimeout(() => {
        dispatch({
          type: 'RESET_ERROR',
        });
      }, 50);
    }
  });
};

export function handleLogout() {
  localStorage.clear();
  return {
    type: 'LOGOUT_SUCCESS',
  };
}

export const handleFetchMe = (token) => (dispatch) => {
  fetch(`${ServerIp}/api/v1/me/show`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      me: {
        auth_token: token,
      },
    }),
  }).then((res) => {
    if (res.status === 200) {
      res.json().then((data) => {
        dispatch({
          type: 'LOGIN_SUCCESS',
          payload: data,
        });
      });
    } else {
      dispatch({
        type: 'LOGIN_FAIL',
        payload: 'Failed to find user, pleas try again!',
      });
      setTimeout(() => {
        dispatch({
          type: 'RESET_ERROR',
        });
      }, 50);
    }
  });
};

export const handleFetchAllUsers = () => (dispatch) => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  dispatch({type: 'GET_ALL_USERS_PENDING'});
  fetch(`${ServerIp}/api/v1/admins/index`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Token token="${token}", identifier="${user}"`,
    },
  }).then((res) => {
    if (res.status === 200) {
      res.json().then((data) => {
        dispatch({
          type: 'GET_ALL_USERS_SUCCESS',
          payload: data,
        });
      });
    } else {
      dispatch({
        type: 'LOGIN_FAIL',
        payload: 'Email or password are wrong, pleas try again!',
      });
      setTimeout(() => {
        dispatch({
          type: 'RESET_ERROR',
        });
      }, 50);
    }
  });
};

export const adminUpdateUser = (user) => (dispatch) => {
  const token = localStorage.getItem('token');
  const username = localStorage.getItem('user');

  fetch(`${ServerIp}/api/v1/admins/update`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Token token="${token}", identifier="${username}"`,
    },
    body: JSON.stringify({ user }),
  }).then((res) => {
    if (res.status < 400) {
      res.json().then((data) => {
        dispatch({
          type: 'UPDATE_USER_SUCCESS',
          payload: data,
        });
      });
    } else {
      dispatch({
        type: 'LOGIN_FAIL',
        payload: 'Update user failed, pleas try again!',
      });
      setTimeout(() => {
        dispatch({
          type: 'RESET_ERROR',
        });
      }, 50);

    }
  });
};

export const adminCreateUser = (user) => (dispatch) => {
  const token = localStorage.getItem('token');
  const username = localStorage.getItem('user');

  fetch(`${ServerIp}/api/v1/admins/create`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Token token="${token}", identifier="${username}"`,
    },
    body: JSON.stringify({
      user: {
        username: user.username,
        email: user.email,
        password: user.password,
        admin: user.admin.toString(),
        company: user.company,
      },
    }),
  }).then((res) => {
    if (res.status < 400) {
      res.json().then((data) => {
        dispatch({
          type: 'CREATE_USER_SUCCESS',
          payload: data,
        });
      });
    } else {
      Alert.error('User create failed', {timeout: 2000});
    }
  });
};

export const adminDeleteUser = (id) => (dispatch) => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  fetch(`${ServerIp}/api/v1/admins/destroy`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Token token="${token}", identifier="${user}"`,
    },
    body: JSON.stringify({
      user: {
        id,
      },
    }),
  }).then((res) => {
    if (res.status < 400) {
      dispatch({
        type: 'DELETE_USER_SUCCESS',
        payload: id,
      });
    } else {
      dispatch({
        type: 'LOGIN_FAIL',
        payload: 'Create user failed, pleas try again!',
      });
      setTimeout(() => {
        dispatch({
          type: 'RESET_ERROR',
        });
      }, 50);
    }
  });
};



// WEBPACK FOOTER //
// ./src/actions/users.js